<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :search="search"
    :items="items"
    sort-by="created_at"
    :sort-desc="true"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>HISTÓRICO DE UPLOAD DE FOTOS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.provider="{ item }">
      {{ item.provider.code }} - {{ item.provider.name }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.collection="{ item }">
      {{ item.collection.name }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.quantity="{ item }">
      {{ item.photos.length }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize()"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { URL } from "@/api/config";

export default {
  data: () => ({
    dialogDelete: false,
    search: "",
    loading: false,
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
        width: 50,
      },
      { text: "Coleção", value: "collection", width: 200 },
      { text: "Fornecedor", value: "provider", width: 200 },
      { text: "Quantidade", value: "quantity", width: 200 },
      { text: "Data", value: "created_at", width: 200 },
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
  }),

  computed: {},

  watch: {},

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.getGaleryPhotos();
    },
    async getGaleryPhotos() {
      this.loading = true;
      try {
        let response = await fetch(`${URL}photo-galery`);
        let data = await response.json();
        this.items = data;
      } catch (error) {
        this.items = [];
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
  },
};
</script>
